import { SuppliersModel } from "../../Models/SuppliersModel";


export const fetchSuppliers = async (): Promise<SuppliersModel[]> => {
    const apiUrl = import.meta.env.VITE_BACKEND_HOST_NAME;
 
    try {
        const response = await fetch(`${apiUrl}alternative/getSuppliers`);
 
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data: SuppliersModel[] = await response.json();
        // const data: SuppliersModel[] = [{Id: 1, Name: "Supplier 1", IsSelected: false, Hits: 0}, {Id: 2, Name: "Supplier 2",  IsSelected: false, Hits: 0}];
        return data;
    } catch (error) {
        console.error('Fetch error:', error);
        return [];
    }
};

export const fetchCompanyGroups = async (): Promise<SuppliersModel[]> => {
    const apiUrl = import.meta.env.VITE_BACKEND_HOST_NAME;
 
    try {
        const response = await fetch(`${apiUrl}alternative/GetCompanyGroups`);
 
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data: SuppliersModel[] = await response.json();
        // const data: SuppliersModel[] = [{Id: 1, Name: "Supplier 1", IsSelected: false, Hits: 0}, {Id: 2, Name: "Supplier 2",  IsSelected: false, Hits: 0}];
        return data;
    } catch (error) {
        console.error('Fetch error:', error);
        return [];
    }
};